import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from '../modules/reducer';
import createMiddleware from '../middleware/clientMiddleware';

export default function configureStore(history, client, initialState) {
  // Sync dispatched route actions to the history
  const reduxRouterMiddleware = routerMiddleware(history);
  const middlewares = [createMiddleware(client), reduxRouterMiddleware];

  return createStore(rootReducer, initialState, applyMiddleware(...middlewares));
}



// WEBPACK FOOTER //
// ./src/state/store/configureStore.prod.js